import { LinearGradient } from "expo-linear-gradient";
import { Divider, HStack, VStack } from "native-base";
import { InterfaceVStackProps } from "native-base/lib/typescript/components/primitives/Stack/VStack";
import React from "react";
import { createShimmerPlaceholder } from "react-native-shimmer-placeholder";

import { isNativeDevice } from "@/utils/platform";

import HorizontalProductList from "../HorizontalProductList";

const ShimmerPlaceholder = createShimmerPlaceholder(LinearGradient);

type ProductSectionListLoadingProps = {
  showDivider?: boolean;
  rows?: number;
} & InterfaceVStackProps;

const ProductSectionListLoading = ({
  showDivider = true,
  rows = 2,
  ...props
}: ProductSectionListLoadingProps) => {
  const fakeData = new Array(rows).fill({});
  const fakeProducts = new Array(isNativeDevice ? 2 : 10).fill({});
  return (
    <>
      {fakeData.map((_, index) => (
        <VStack
          key={index}
          my="4"
          mx="1"
          p="4"
          bgColor="white.50"
          shadow="4"
          rounded="lg"
          {...props}>
          <HStack justifyContent="space-between" alignItems="center" mb={!showDivider ? 1 : 0}>
            <ShimmerPlaceholder />
          </HStack>
          {showDivider && <Divider my="4" />}
          <HorizontalProductList data={fakeProducts} isLoading={true} onSelect={() => {}} />
        </VStack>
      ))}
    </>
  );
};

export default ProductSectionListLoading;
